import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=591ca060&scoped=true"
import script from "./ItemSelector.vue?vue&type=script&lang=js"
export * from "./ItemSelector.vue?vue&type=script&lang=js"
import style0 from "./ItemSelector.vue?vue&type=style&index=0&id=591ca060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ca060",
  null
  
)

export default component.exports